import pic1 from "../assets/img/pic1.png";
import pic2 from "../assets/img/pic2.png";
import pic3 from "../assets/img/pic3.png";
import triangle from "../assets/img/triangle.svg";
import { CarouselPage } from "./CarouselPage";
import { NewsHome } from './NewsHome';
import { useUserContext } from "../components/auth/userContext";
import { useNavigate } from 'react-router-dom';

export const Home = () => {
  const { userInfo } = useUserContext();
  console.log(userInfo);
  const navigate = useNavigate();

  return (
    <>
      <div className="home grid grid-cols-1 lg:grid-cols-5 items-center max-w-[1500px] mx-auto lg:border-4 border-gray-200">
        <div className="lg:col-span-3">
          <CarouselPage />
        </div>
        <div className='w-full lg:relative lg:col-span-2 text-Headline px-4 lg:px-6 mx-auto'>
          <div className="flex justify-between items-end mt-6 mb-4 lg:mt-0 ">
            <div className="hidden lg:block w-24"></div>
            <div className='news text-lg lg:text-xl w-fit border-b-4 border-primary font-medium p-1 lg:p-2 mx-auto'>最新消息</div>
            <div className='rounded-3xl bg-[#6cd5cc] text-white text-sm cursor-pointer hover:opacity-80 w-fit px-4 py-1 hidden lg:block'
              onClick={() => navigate('/newsall?init=true')}>查看更多</div>
          </div>
          <NewsHome />
        </div>
      </div>
      <div className='mt-9 lg:mt-[72px]'>
        <div className="pt-4 pb-16" style={{ backgroundImage: `url(/images/qrcodebg.svg)`, backgroundSize: 'cover', backgroundPosition: 'right top' }}>
          <div className="flex flex-col lg:flex-row items-start lg:items-center max-w-[1600px] gap-x-6 gap-y-6 mx-auto px-4">
            <div className="htitle news text-Headline w-full max-w-xl text-nowrap border-l-4 mx-auto pl-2" style={{borderImage: 'linear-gradient(to bottom, #DA5D5D, #515050) 1', borderImageSlice: 1}}>
              <div className="text-[1.25rem] md:text-[1.5rem] lg:text-[8cqw] lg:leading-[9cqw] text-warning font-medium lg:mb-3">歡迎加入！</div>
              <div className="text-[1.25rem] md:text-[1.5rem] lg:text-[8cqw] lg:leading-[9cqw] font-medium">LINE官方帳號及雲端學校APP</div>
              {/* <ul className="text-lg md:text-2xl !leading-7 md:!leading-9 !ml-12 md:!ml-16 my-4 md:my-14">
                <li>研習活動推播</li>
                <li>計劃相關資訊</li>
                <li>載具疑問解答</li>
              </ul> */}
              {/* <div className="text-base md:text-xl">加入後請記得先傳一張貼圖給我們呦！</div> */}

            </div>
            <div className="mx-auto my-4 md:mt-12 md:mb-auto px-6">
              <img src="/images/lqrcode.png" alt="" className="sm:w-4/5 mx-auto" />
              <a href="https://line.me/R/ti/p/@115eiokc" target='_blank' rel="noreferrer">
                <div className='bt-green text-xl md:text-3xl font-normal w-[120px] md:w-[200px] whitespace-nowrap py-4 md:py-[18px] mt-5 ml-auto cursor-pointer hover:opacity-80 mx-auto'>點選加入</div>
              </a>
              <div className="text-base md:text-xl text-center mt-8">加入後請記得先傳一張貼圖給我們呦！</div>
            </div>
            <div className="mx-auto my-4 md:mt-12 md:mb-auto px-6">
              <img src="/images/kqrcode.png" alt="" className="sm:w-4/5 mx-auto" />
              <a href="https://appurl.io/no-SeE4bEw" target='_blank' rel="noreferrer">
                <div className='bt-purple text-xl md:text-3xl font-normal w-[120px] md:w-[200px] whitespace-nowrap py-4 md:py-[18px] mt-5 ml-auto cursor-pointer hover:opacity-80 mx-auto'>點選加入</div>
              </a>
              <div className="text-base md:text-xl text-center mt-8">請用高雄市政府教育局OPEN ID帳號登入</div>
            </div>
          </div>
        </div>
        {/* <div className='content flex flex-col-reverse lg:flex-row justify-between items-center lg:items-start gap-x-16 gap-y-6 px-6 mx-auto p-16'>
          <div className='max-w-3xl w-full text-center lg:text-left font-medium'>
            <div className='text-lg lg:text-4xl text-[#F9F871]'>共創師生學習之旅</div>
            <div className='text-lg lg:text-4xl text-white pt-1 pb-6 lg:pt-6 lg:pb-10'>探索數位學習的無限可能</div>
            <div className='text-base lg:text-2xl text-white font-normal text-justify'>歡迎蒞臨高雄市數位學習入口網，這裡不僅是知識的樂園，更是師生互動與合作的據點。我們提供多樣化的學習工具和互動功能，讓教學和學習變得更加生動有趣。高雄市數位學習入口網具備單一登入功能，師生可使用Open ID輕鬆登入，享受豐富的學習資源。我們致力打造先進、便利且有趣的數位學習環境，歡迎高雄市的師生加入我們，共同探索無限的學習可能。</div>
          </div>
          <div className='w-full max-w-[418px] px-8 lg:p-0'>
            <img src={pic1} alt="" />
          </div>
        </div> */}
      </div>
      {/* <img src={triangle} alt="" className='mx-auto -mt-1 w-20 lg:w-36' /> */}

      {/* <div className='content flex flex-col lg:flex-row justify-between items-center lg:items-start gap-x-16 gap-y-6 px-6 mx-auto mt-6 lg:mt-16'>
        <div className='w-full max-w-[418px] px-8 lg:p-0'>
          <img src={pic2} alt="" />
        </div>
        <div className='max-w-3xl w-full text-center lg:text-left font-medium'>
          <div className='text-lg lg:text-4xl text-[#DA5D5D]'>優化教學體驗</div>
          <div className='text-lg lg:text-4xl text-Headline pt-1 pb-6 lg:pt-6 lg:pb-10'>專屬於教師的多樣化資源</div>
          <div className='text-base lg:text-2xl font-normal text-justify'>透過高雄市數位學習入口網，教師們可以輕鬆地使用網路資源進行教學，豐富課堂內容，增加學生的學習樂趣。同時，我們提供了線上報修、WebITR差勤系統、線上預約等功能，讓您能夠輕鬆管理課堂運作、處理學生學習問題，並安排與學生的會議時間。這一系列功能的整合，讓您能夠在高雄市數位學習入口網中高效完成所有業務，更專注於教學本身。</div>
          <a href="./api/auth/login_ischool?linkSignIn=khoidc&restore_url=/main"><div className='bt-purple text-sm lg:text-3xl font-normal w-[96px] lg:w-[200px] whitespace-nowrap py-2 lg:py-[18px] mt-5 ml-auto cursor-pointer hover:opacity-80'>馬上體驗</div></a>
        </div>
      </div> */}

      {/* <div className='content flex flex-col-reverse lg:flex-row justify-between items-center lg:items-start gap-x-16 gap-y-6 px-6 mx-auto mt-6 lg:mt-16'>
        <div className='max-w-3xl w-full text-center lg:text-left font-medium'>
          <div className='text-lg lg:text-4xl text-[#DA5D5D]'>數位資源一站式</div>
          <div className='text-lg lg:text-4xl text-Headline pt-1 pb-6 lg:pt-6 lg:pb-10'>學習暢遊無阻不再繁瑣複雜</div>
          <div className='text-base lg:text-2xl font-normal text-justify'>透過高雄市數位學習入口網，學生們將能夠輕鬆使用天下雜誌群知識庫、均一教育平台、學習吧、PaGamO、LoiLoNote School、Adobe Creative Cloud、威力導演等多樣化的數位資源。師生只需透過高雄市Open ID帳號登入，即可享受無縫的學習體驗，拓展知識、培養技能，為未來的成長鋪就堅實的基礎。</div>
          <a href="./api/auth/login_ischool?linkSignIn=khoidc&restore_url=/main"><div className='bt-green text-sm lg:text-3xl font-normal w-[96px] lg:w-[200px] whitespace-nowrap py-2 lg:py-[18px] mt-5 ml-auto cursor-pointer hover:opacity-80'>馬上體驗</div></a>
        </div>
        <div className='w-full max-w-[418px] px-8 lg:p-0'>
          <img src={pic3} alt="" />
        </div>
      </div> */}


      {/* <div className='p-7 lg:p-16'></div> */}
    </>
  )
}